// Mock data for One More International website

export const heroSlides = [
  {
    id: 1,
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/8ny3wqgo_Ads%C4%B1z%20tasar%C4%B1m%20%285%29.png',
    title: 'One More International',
    subtitle: 'Daha iyi bir sen için ilk adımı at!'
  },
  {
    id: 2,
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/f5ymk5ve_Ads%C4%B1z%20tasar%C4%B1m%20%284%29.png',
    title: 'Yenilikçi Çözümler',
    subtitle: 'Gelişmiş Teknoloji ile Özel Ürünler'
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1920&h=800&fit=crop',
    title: '15 Milyon+ Kullanıcı',
    subtitle: 'Milyonlarca İnsanın Tercihi'
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&h=800&fit=crop',
    title: '%98 Müşteri Memnuniyeti',
    subtitle: 'Kalite ve Güven ile Hizmetinizdeyiz'
  },
  {
    id: 5,
    image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1920&h=800&fit=crop',
    title: '100+ Ülkeye İhracat',
    subtitle: 'Dünya Çapında Güvenilir İş Ortağınız'
  }
];

export const categories = [
  {
    id: 1,
    name: 'One More Transdermal Ürünler',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/qwpr0azl_1.png',
    description: 'Onemore International\'ın transdermal ürünleri ile tanışın, hayat kalitenizi artırın.',
    products: [
      {
        id: 'trans-1',
        name: 'ONE MORE PAINLESS NIGHT GLU',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/s57fmqus_1.png',
        description: 'Enerjini topla, kaliteli yaşa!'
      },
      {
        id: 'trans-2',
        name: 'ONE MORE B12 PLUS',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/dlok41s1_2.png',
        description: 'Vitaminlerle güçlen!'
      },
      {
        id: 'trans-3',
        name: 'ONE MORE DEKAMIN',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/8e5lwadm_3.png',
        description: 'Kendini iyi hisset!'
      },
      {
        id: 'trans-4',
        name: 'ONE MORE OMEVIA',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/myrlej1j_4.png',
        description: 'Kendine iyi bak!'
      },
      {
        id: 'trans-5',
        name: 'ONE MORE MELATONIN PLUS',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/691p11p9_5.png',
        description: 'Güne dinamik ve keyifle başla!'
      },
      {
        id: 'trans-6',
        name: 'ONE MORE SLIM STYLE',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/r2auci5q_6.png',
        description: 'İdeal formuna kavuş!'
      },
      {
        id: 'trans-7',
        name: 'ONE MORE NIGHT LADIES',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/ta5akc15_7.png',
        description: 'Patch formatında doğal afrodizyak!'
      },
      {
        id: 'trans-8',
        name: 'ONE MORE NIGHT GENTLEMEN',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/96npi8ig_8.png',
        description: 'Patch formatında doğal afrodizyak!'
      },
      {
        id: 'trans-9',
        name: 'ONE MORE COLLAGEN PATCH',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/42a95s7j_9.png',
        description: 'Yaşlanma etkilerini geciktirin!'
      },
      {
        id: 'trans-10',
        name: 'ONE MORE GLUTAMORE',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/klf3cg52_10.png',
        description: 'En iyi versiyonun için!'
      }
    ]
  },
  {
    id: 2,
    name: 'Kişisel Bakım ve Hijyen',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/8g920jgu_2.png',
    description: 'Onemore International ürünleri ile doğal güzelliğinizi keşfedin, kendinize iyi bakın!',
    products: [
      {
        id: 'beauty-1',
        name: 'ANTI-AGING MASK 8\'li',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/vj0xqzsn_11.png',
        description: 'Yaşlanma etkilerini geciktirin!'
      },
      {
        id: 'beauty-2',
        name: 'ANTI-AGING MASK 4\'lü',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/zp2ho1da_12.png',
        description: 'Yaşlanma etkilerini geciktirin!'
      },
      {
        id: 'beauty-3',
        name: 'SUN SCREEN',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/0k3f2cay_13.png',
        description: 'Cildine ışıltı ve koruma kat!'
      },
      {
        id: 'beauty-4',
        name: 'HAIR REPAIR SHAMPOO',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/xamj6e80_14.png',
        description: 'Göz alıcı saçlar için!'
      },
      {
        id: 'beauty-5',
        name: 'HAIR REPAIR MASK',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/jvmwn3gz_15.png',
        description: 'Işıl ışıl ve ipeksi saçlar!'
      },
      {
        id: 'beauty-6',
        name: 'SHOWER GEL',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/b5otf43x_16.png',
        description: 'Yumuşak dokunuş, ferah bir his!'
      },
      {
        id: 'beauty-7',
        name: 'OMIPRODENT TOOTHPASTE',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/t74ors06_17.png',
        description: 'Profesyonel bakım diş macunu!'
      },
      {
        id: 'beauty-8',
        name: 'OMICLEAN POWDER',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/h8oiukwg_18.png',
        description: 'Leke çıkarıcı toz!'
      },
      {
        id: 'beauty-9',
        name: 'OMICLEAN WIPES',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/deopsxly_19.png',
        description: 'Leke çıkarıcı mendil!'
      }
    ]
  },
  {
    id: 3,
    name: 'Omicoff Kahve Serisi',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/3v3wdewc_3.png',
    description: 'Onemore International Omicoff kahve serisi. Eşsiz lezzetleriyle vücudunuzu destekleyin!',
    products: [
      {
        id: 'coffee-1',
        name: 'OMICOFF CLASSIC 30x3 gr',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/qp70glj9_23.png',
        description: 'Bir kahveden fazlası!'
      },
      {
        id: 'coffee-2',
        name: 'OMICOFF CLASSIC 250 gr',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/j78ycre7_24.png',
        description: 'Eşsiz kahve lezzetleriyle buluşun!'
      },
      {
        id: 'coffee-3',
        name: 'OMICOFF LATTE 20x14 gr',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/lw8lxw8v_25.png',
        description: 'Bir kahveden fazlası!'
      },
      {
        id: 'coffee-4',
        name: 'OMICOFF LATTE 250 gr',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/wuj6dhxu_26.png',
        description: 'Eşsiz kahve lezzetleriyle buluşun!'
      },
      {
        id: 'coffee-5',
        name: 'OMICOFF MOCHA 20x14 gr',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/y75raaw5_27.png',
        description: 'Bir kahveden fazlası!'
      },
      {
        id: 'coffee-6',
        name: 'OMICOFF MOCHA 250 gr',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/d53wt4k3_28.png',
        description: 'Eşsiz kahve lezzetleriyle buluşun!'
      }
    ]
  },
  {
    id: 4,
    name: 'One More Pawsy Pet Care',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/12n3g6fc_4.png',
    description: 'Onemore International Pawsy ürünleri ile evcil hayvan dostlarınızın bakımları artık çok daha kolay.',
    products: [
      {
        id: 'pawsy-1',
        name: 'PAWSY NANO SPRAY',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/2dz7zmz1_20.png',
        description: 'One More ile mutlu evcil dostlar!'
      },
      {
        id: 'pawsy-2',
        name: 'PAWSY TOWEL',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/tj8y8wxf_21.png',
        description: 'One More ile mutlu evcil dostlar!'
      },
      {
        id: 'pawsy-3',
        name: 'PAWSY WIPES',
        image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/2bmw4ez7_22.png',
        description: 'One More ile mutlu evcil dostlar!'
      }
    ]
  }
];

export const stats = [
  {
    id: 1,
    icon: 'Users',
    value: '15M+',
    label: 'Ürün Kullanıcısı'
  },
  {
    id: 2,
    icon: 'Heart',
    value: '%98',
    label: 'Müşteri Memnuniyeti'
  },
  {
    id: 3,
    icon: 'Globe',
    value: '100+',
    label: 'Ülkeye Mikro İhracat'
  },
  {
    id: 4,
    icon: 'Package',
    value: '23',
    label: 'Ürün Sayısı'
  }
];

export const certificates = [
  {
    id: 1,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/m26mb6ng_1.jpg',
    date: ''
  },
  {
    id: 2,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/dv19l4um_2.jpg',
    date: ''
  },
  {
    id: 3,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/t0bzqq3q_3.jpg',
    date: ''
  },
  {
    id: 4,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/q1jyqbuu_4.jpg',
    date: ''
  },
  {
    id: 5,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/xa3lfm1m_5.jpg',
    date: ''
  },
  {
    id: 6,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/k9sc1wmy_6.jpg',
    date: ''
  },
  {
    id: 7,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/8ttn9yxw_7.jpg',
    date: ''
  },
  {
    id: 8,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/v3hwh7hl_8.jpg',
    date: ''
  },
  {
    id: 9,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/axfr38vv_9.jpg',
    date: ''
  },
  {
    id: 10,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/shhtljzb_10.jpg',
    date: ''
  },
  {
    id: 11,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/80hf0nt8_11.jpg',
    date: ''
  },
  {
    id: 12,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/do2vr81s_12.jpg',
    date: ''
  },
  {
    id: 13,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/9wm68u8o_13.jpg',
    date: ''
  },
  {
    id: 14,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/70v09q18_14.jpg',
    date: ''
  },
  {
    id: 15,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/a47poimi_15.jpg',
    date: ''
  },
  {
    id: 16,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/l7z875nc_16.jpg',
    date: ''
  },
  {
    id: 17,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/n9z8jplq_17.jpg',
    date: ''
  },
  {
    id: 18,
    name: '',
    image: 'https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/b8z3dc2j_18.jpg',
    date: ''
  }
];

export const faqs = [
  {
    id: 1,
    question: 'One More International ürünleri nasıl sipariş edebilirim?',
    answer: 'Sitemizden kayıt olarak hızlıca alışverişe başlayabilirsiniz. Kayıt işlemi çok basit ve hızlıdır.'
  },
  {
    id: 2,
    question: 'Kayıt olmanın avantajları nelerdir?',
    answer: 'Kayıt olduğunuzda sadece size özel sayfanızdan ürünlerimizi daha uygun, daha avantajlı ve kampanyalı fiyatlardan, hem resmi olarak, hem de güvenle alabilirsiniz. İstediğiniz her an, her yerden sipariş oluşturabilirsiniz.'
  },
  {
    id: 3,
    question: 'Kayıt olmanın dezavantajı var mı?',
    answer: 'Kayıt olmanız size One More Şirketinden resmi olarak alışveriş yapma imkanı sağlar. Onun dışında sürekli reklam mesajları, aranmalar gibi durumlar ile karşılaşmazsınız. Ayrıca kayıt olmanın herhangi bir yaptırımı yoktur. Kayıt ücreti, aidat vs. gibi ücretler yoktur.'
  },
  {
    id: 4,
    question: 'Nasıl kayıt olabilirim?',
    answer: 'Sitemiz üzerinden Kayıt ol yada Alışverişe Başla seçtiğinizde One More International\'ın resmi kayıt sayfasına yönlendirileceksiniz. Ülke seçimi sonrası, kişisel bilgilerinizi girerek, şifrenizi belirleyerek kaydınızı oluşturabilirsiniz. Hesabınıza giriş yaparak mail ve şifreniz ile kendi hesabınızdan alışverişinizi yapabilirsiniz.'
  },
  {
    id: 5,
    question: 'Sorularım olması halinde size nerden ulaşabilirim?',
    answer: 'Whatsapp iletişim kanalımızdan herhangi bir sorunuz yada yardımcı olmamızı istediğiniz bilgi edinme, kayıt işlemleri, sipariş, ürün kullanımı gibi One More International\'e ait tüm konularda her zaman yanınızdayız.'
  }
];

export const aboutInfo = {
  title: 'Hakkımızda',
  description: 'Onemore International resmi distribütör ekibi ile doğru bilgilendirme, ürün kullanımı ve doğru yönlendirme için buradayız. Detaylı bilgi ve sorularınız için iletişime geçebilirsiniz.',
  mainText: 'One More International kurulduğu günden bu yana kaliteli, eşsiz ürün gamı ve gelişmiş teknolojisiyle birlikte birbirinden özel ürünleri sadece Türkiye\'ye değil tüm dünyaya sunuyor.'
};

export const contactInfo = {
  phone: '+90 535 065 70 41',
  whatsapp: '+905350657041',
  email: 'bantlayenilen@gmail.com'
};